export interface TicFinancialFileIds {
  summaryId: number;
  fileId: number;
}

/**
 * TIC document URLs look like …/financial-documents/se/520470 (new format)
 * or …/financial-documents/se/48779999_0 (older format).
 * A missing file index is 0. The PDF API accepts that and does not forward it to TIC.
 */
export function financialFileIdsFromUrl(
  documentUrl: string | undefined,
): TicFinancialFileIds | null {
  if (!documentUrl || typeof documentUrl !== 'string') {
    return null;
  }
  const m = documentUrl.match(/financial-documents\/[^/]+\/(\d+)(?:_(\d+))?\/?(?:\?|$)/i);
  if (!m) {
    return null;
  }
  return {
    summaryId: parseInt(m[1], 10),
    fileId: m[2] != null ? parseInt(m[2], 10) : 0,
  };
}
